import { defineComponent as n, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as v } from "vue";
const _ = ["viewBox"], f = /* @__PURE__ */ e("mask", { id: "902c1be7-d83d-47ea-a142-b81d039e6abe" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#902c1be7-d83d-47ea-a142-b81d039e6abe)" }, m = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M0 0h512v512H0Z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M256 56c-7 0-12 5-12 12v128h-24v-92a12 12 0 0 0-24 0v92h-92a12 12 0 0 0 0 24h92v24H68a12 12 0 0 0 0 24h128v24h-92a12 12 0 0 0 0 24h92v92c0 7 5 12 12 12s12-5 12-12v-92h24v128c0 7 5 12 12 12s12-5 12-12V316h24v92c0 7 5 12 12 12s12-5 12-12v-92h92c7 0 12-5 12-12s-5-12-12-12h-92v-24h128c7 0 12-5 12-12s-5-12-12-12H316v-24h92c7 0 12-5 12-12s-5-12-12-12h-92v-92a12 12 0 0 0-24 0v92h-24V68c0-7-5-12-12-12z"
}, null, -1), g = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "88",
  fill: "#d80027"
}, null, -1), x = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "64",
  fill: "#ffda44"
}, null, -1), y = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ n({
  __name: "us-nm",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (b, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      f,
      e("g", u, [
        t.flagName ? (c(), i("title", m, d(t.flagName), 1)) : h("", !0),
        k,
        p,
        g,
        x
      ]),
      e("g", y, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: v({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=us-nm-90ec826a.js.map
